import { AlertColor } from '@mui/material'
import { atom } from 'recoil'

export type ClientData = {
  label: string
  value: string
  enabled?: boolean
  client_id?: number
  client_name?: string
  client_phone?: string
  client_street?: string
  client_street2?: string
  client_city?: string
  client_state?: string
  client_zip?: string
	package?: number
	everify?: boolean
  syncID?: string
  trackerClientId?: number,
  viewMigratedData?: boolean
}

export type CCTConfig = {
  showAlert: boolean;
  isUpdate: boolean;
  alertTitle?: string;
  alertMessage?: string;
  alertSeverity?: AlertColor;
}

export type Package = {
  displayName: string
  id: number
}

const data = {
  enabled: true,
  package: 0,
} as ClientData

const config = {
  isUpdate: false,
  showAlert: false
} as CCTConfig

const clientConfigState = atom({
  default: { config, data },
  key: 'clientState',
})

export const packageFeatureState = atom({
  default: [] as Package[],
  key: 'packagesArray',
})

export default clientConfigState
